import { css } from '@emotion/react'
import MenuIcon from '@mui/icons-material/Menu'
import { memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import IconButton from './IconButton'

const buttonStyles = css({
    padding: getThemeSpacing(0.875),
})

interface IButtonMenu {
    onClick(event?: any): void
    title?: string
}

const ButtonMenu = memo(({ onClick, title }: IButtonMenu) => (
    <IconButton title={title ?? 'Menu'} onClick={onClick} css={buttonStyles}>
        <MenuIcon data-testid="MenuIcon" />
    </IconButton>
))

export default ButtonMenu
